module.exports = __webpack_public_path__ + "static/who_we_work_with_banner_hover-8c8b6e722455fa4016fd014ab2082d0a.jpg";